// extracted by mini-css-extract-plugin
module.exports = {"venue-input":"Course_venue-input__3QcQS","section-subtitle-text":"Course_section-subtitle-text__1xk5b","condensed-btn":"Course_condensed-btn__2H2T8"};